/**
 * Angucomplete
 * Autocomplete directive for AngularJS
 * By Daryl Rowland
 * https://github.com/darylrowland/angucomplete
 *
 * ZOETIS: Modified and Customized
 */
import get from 'lodash/get';

angular
  .module('angucomplete', [])
  .directive('angucomplete', function ($parse, $http, $sce, $timeout) {
    return {
      restrict: 'EA',
      scope: {
        id: '@id',
        ngDisabled: '=',
        placeholder: '@placeholder',
        selectedObject: '=selectedobject',
        url: '@url',
        dataField: '@datafield',
        isClearAfterSelect: '@isclearafterselect',
        searchFn: '&searchFn',
        nextFn: '&nextFn', // ZOETIS - MODIFIED: For infinite scroll next page function
        titleField: '@titlefield',
        descriptionField: '=descriptionfield',
        imageField: '@imagefield',
        imageUri: '@imageuri',
        inputClass: '@inputclass',
        userPause: '@pause',
        localData: '=localdata',
        searchFields: '@searchfields',
        minLengthUser: '@minlength',
        matchClass: '@matchclass',
        onSelect: '&onSelect', // ZOETIS - MODIFIED: Added Callback
        preselected: '=preselected', // ZOETIS - MODIFIED: Added preselect value
        keyField: '@keyfield',
      },
      // ZOETIS - MODIFIED: Separated html template into a file
      // Converted to multiline template
      template:
        '<div class="angucomplete-holder">' +
        '<div class="angucomplete-input">' +
        '<input ng-disabled={{ngDisabled}} id="{{id}}_value" ng-model="searchStr" type="text" placeholder="{{placeholder}}" class="{{inputClass}}" onmouseup="this.select();"/>' +
        '<span class="fa fa-search angucomplete-search-icon"></span>' +
        '</div>' +
        '<div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-if="showDropdown">' +
        '<div class="angucomplete-searching" ng-show="searching">Searching...</div>' +
        '<div class="angucomplete-row" ng-repeat="result in results" ng-mousedown="selectResult(result)" ng-mouseover="hoverRow()" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">' +
        '<div ng-if="imageField" class="angucomplete-image-holder"><img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}"  class="angucomplete-image"/>' +
        '<div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div>' +
        '</div>' +
        '<div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' +
        '<div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>' +
        '<div ng-if="(result.description && result.description != \'\') && !matchClass" class="angucomplete-description" ng-if="!matchClass">{{ result.description }}</div>' +
        '<div class="angucomplete-description" ng-if="(result.description && result.description != \'\') && matchClass" ng-bind-html="result.description"></div>' +
        '</div>' +
        '<div class="angucomplete-searching" ng-show="isUser && !searching && (!results || results.length < 3)">' +
        'Not finding the user you\'re looking for? <br> Keep typing the full email address to find a match. If there are still no results, <a style="font-weight:bold;" class="orange-link" ng-href="./rewards">Invite the User.</a>' +
        '</div>' +
        '<div class="angucomplete-searching" ng-show="!searching && (!results || results.length === 0)">' +
        'No results are found' +
        '</div>' +
        '</div>' +
        '</div>',
      link: function ($scope, elem, attrs) {
        $scope.lastSearchTerm = null;
        $scope.currentIndex = null;
        $scope.justChanged = false;
        $scope.searchTimer = null;
        $scope.hideTimer = null;
        $scope.searching = false;
        $scope.pause = 500;
        $scope.minLength = 3;
        $scope.searchStr = null;
        $scope.scrollList = null; //ZOETIS - Added for infinite scroll target list property
        $scope.nextPage = null; //ZOETIS - Added for infinite scroll next page value from response
        $scope.processing = false; //ZOETIS - Added for infinite scroll next page fixing
        $scope.isUser = (attrs.isuser ?? true) === true;

        if ($scope.minLengthUser && $scope.minLengthUser != '') {
          $scope.minLength = $scope.minLengthUser;
        }

        if ($scope.userPause) {
          $scope.pause = $scope.userPause;
        }

        $scope.isNewSearchNeeded = function (newTerm, oldTerm) {
          return newTerm.length >= $scope.minLength && newTerm != oldTerm;
        };

        $scope.processResults = function (responseData, str) {
          // ZOETIS - MODIFIED: For infinite scroll to accept and set nextPage parameter if available, or reset if not
          $scope.processing = true;
          if (responseData) {
            var meta = null;
            if (responseData.meta) {
              meta = responseData.meta;
              if (meta.next) {
                $scope.nextPage = meta.next;
              } else {
                $scope.nextPage = null;
              }
            }
            responseData = responseData[$scope.dataField || 'identities'];
          }
          if (responseData && responseData.length > 0) {
            // ZOETIS - MODIFIED: For infinite scroll to not reset results if adding a page
            if ($scope.nextPage) {
              //$scope.results = [];
            }
            var titleFields = [];
            if ($scope.titleField && $scope.titleField != '') {
              titleFields = $scope.titleField.split(',');
            }

            for (var i = 0; i < responseData.length; i++) {
              // Get title variables
              var titleCode = [];

              for (var t = 0; t < titleFields.length; t++) {
                titleCode.push(responseData[i][titleFields[t]]);
              }

              var description = '';
              if ($scope.descriptionField) {
                description = get(responseData[i], $scope.descriptionField);
              }

              var imageUri = '';
              if ($scope.imageUri) {
                imageUri = $scope.imageUri;
              }

              var image = '';
              if ($scope.imageField) {
                image = imageUri + responseData[i][$scope.imageField];
              }

              var text = titleCode.join(' ');
              if ($scope.matchClass) {
                var re = new RegExp(str, 'i');

                // ZOETIS - MODIFIED: Fixed issue for when search query only match description
                if (text.match(re)) {
                  var strPart = text.match(re)[0];
                  text = $sce.trustAsHtml(
                    text.replace(
                      re,
                      '<span class="' + $scope.matchClass + '">' + strPart + '</span>',
                    ),
                  );
                }

                // ZOETIS - MODIFIED: Added description to search match
                if (description.match(re)) {
                  var decPart = description.match(re)[0];
                  description = $sce.trustAsHtml(
                    description.replace(
                      decPart,
                      '<span class="' + $scope.matchClass + '">' + decPart + '</span>',
                    ),
                  );
                }
              }

              var resultRow = {
                title: text,
                description: description,
                image: image,
                originalObject: responseData[i],
              };

              $scope.results[$scope.results.length] = resultRow;
            }
            // ZOETIS - MODIFIED: For infinite scroll setting scroll element when exists and monitoring scrolling
            $scope.scrollList = $(elem).find('.angucomplete-dropdown');
            $scope.scrollMonitor();
            $scope.processing = false;
          } else {
            //$scope.results = [];
          }
        };

        $scope.searchTimerComplete = function (str) {
          // Begin the search

          if (str.length >= $scope.minLength) {
            if ($scope.localData) {
              var searchFields = $scope.searchFields.split(',');

              var matches = [];

              for (var i = 0; i < $scope.localData.length; i++) {
                var match = false;

                for (var s = 0; s < searchFields.length; s++) {
                  match =
                    match ||
                    (typeof $scope.localData[i][searchFields[s]] === 'string' &&
                      typeof str === 'string' &&
                      $scope.localData[i][searchFields[s]]
                        .toLowerCase()
                        .indexOf(str.toLowerCase()) >= 0);
                }

                if (match) {
                  matches[matches.length] = $scope.localData[i];
                }
              }

              $scope.searching = false;
              $scope.processResults(matches, str);
            }
            // ZOETIS - MODIFIED: Added searchFn to call controller method and return data into dataField for autocomplete
            else if ($scope.searchFn) {
              $scope.searchFn({ query: str }).then(
                function (response) {
                  $timeout(() => {
                    $scope.searching = false;
                    $scope.processResults(response, str);
                  });
                },
                function (error) {
                  console.log('error');
                },
              );
            } else {
              $http
                .get($scope.url + str, {})
                .success(function (responseData, status, headers, config) {
                  $scope.searching = false;
                  $scope.processResults(responseData, str);
                })
                .error(function (data, status, headers, config) {
                  console.log('error');
                });
            }
          }
        };

        $scope.hideResults = function () {
          $scope.hideTimer = $timeout(function () {
            $scope.showDropdown = false;
          }, $scope.pause);
        };

        $scope.resetHideResults = function () {
          if ($scope.hideTimer) {
            $timeout.cancel($scope.hideTimer);
          }
        };

        $scope.hoverRow = function (index) {
          $scope.currentIndex = index;
        };

        $scope.keyPressed = function (event) {
          if (!(event.which == 38 || event.which == 40 || event.which == 13)) {
            if (!$scope.searchStr || $scope.searchStr == '') {
              $scope.showDropdown = false;
              $scope.lastSearchTerm = null;
            } else if ($scope.isNewSearchNeeded($scope.searchStr, $scope.lastSearchTerm)) {
              $scope.lastSearchTerm = $scope.searchStr;
              $scope.showDropdown = true;
              $scope.currentIndex = -1;
              $scope.results = [];

              if ($scope.searchTimer) {
                $timeout.cancel($scope.searchTimer);
              }

              $scope.searching = true;

              $scope.searchTimer = $timeout(function () {
                $scope.searchTimerComplete($scope.searchStr);
              }, $scope.pause);
            }
          } else {
            event.preventDefault();
          }
        };

        $scope.selectResult = function (result) {
          if ($scope.matchClass) {
            result.title = result.title.toString().replace(/(<([^>]+)>)/gi, '');
          }

          if (result.title == ' ' || result.title == '   ') {
            result.title = result.description.toString().replace(/(<([^>]+)>)/gi, '');
          }
          $scope.searchStr = $scope.lastSearchTerm = result.title;
          $scope.selectedObject = result;
          $scope.showDropdown = false;
          $scope.results = [];

          // ZOETIS - MODIFIED: Added Callback onSelect to call method after item selection
          if ($scope.onSelect) {
            $scope.onSelect({ item: result.originalObject });
          }
          if ($scope.isClearAfterSelect) {
            $scope.searchStr = null;
          }
        };

        // ZOETIS - MODIFIED: Preselect value if coming from another page
        if ($scope.preselected != null && $scope.preselected != '') {
          $scope.selectResult($scope.preselected);
        }

        // ZOETIS - MODIFIED: For infinite scroll monitoring scroll position and requesting next page if available
        $scope.scrollMonitor = function () {
          $scope.scrollList.scroll(function (event) {
            var scroll = $scope.scrollList.scrollTop();
            var scrollHeight =
              elem.find('.angucomplete-row').outerHeight() * elem.find('.angucomplete-row').length -
              elem.find('.angucomplete-row').outerHeight() * 5;
            if (
              $scope.nextPage &&
              scroll >= scrollHeight &&
              !$scope.searching &&
              !$scope.processing
            ) {
              $scope.searching = true;
              $scope.nextFn({ query: $scope.nextPage }).then(
                function (response) {
                  $timeout(() => {
                    $scope.searching = false;
                    $scope.processResults(response, '');
                  });
                },
                function (error) {
                  console.log('error');
                },
              );
            }
            // Do something
          });
        };

        $scope.$watch('searchStr', () => {
          if (!$scope.searchStr) {
            $scope.results = [];
            $scope.showDropdown = false;
            $scope.lastSearchTerm = null;
          }
        });

        var inputField = elem.find('input');

        inputField.on('keyup', $scope.keyPressed);

        elem.on('keyup', function (event) {
          if (event.which === 40) {
            if ($scope.results && $scope.currentIndex + 1 < $scope.results.length) {
              $scope.currentIndex++;
              $timeout();
              event.preventDefault;
              event.stopPropagation();
            }
          } else if (event.which == 38) {
            if ($scope.currentIndex >= 1) {
              $scope.currentIndex--;
              $timeout();
              event.preventDefault;
              event.stopPropagation();
            }
          } else if (event.which == 13) {
            if (
              $scope.results &&
              $scope.currentIndex >= 0 &&
              $scope.currentIndex < $scope.results.length
            ) {
              $scope.selectResult($scope.results[$scope.currentIndex]);
              $timeout();
              event.preventDefault;
              event.stopPropagation();
            } else {
              $scope.results = [];
              $timeout();
              event.preventDefault;
              event.stopPropagation();
            }
          } else if (event.which == 27) {
            $scope.results = [];
            $scope.showDropdown = false;
            $timeout();
          } else if (event.which == 8) {
            $scope.selectedObject = null;
            $timeout();
          }
        });

        elem.on('click', function (event) {
          event.stopPropagation();
        });

        $(document).on('click', function (event) {
          if ($scope.showDropdown === true) {
            $scope.hideResults();
          }
        });
      },
    };
  });
